var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import { useBig } from '../hooks/Context';
const useStyles = makeStyles((theme) => ({
    button: {
        color: theme.palette.links,
    },
}));
const CardButton = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = useStyles();
    const big = useBig();
    return (React.createElement(Button, Object.assign({ className: `${className} ${classes.button}`, size: big ? 'medium' : 'small' }, rest)));
};
CardButton.displayName = 'Card.Button';
const CardButtonExtra = styled(CardButton) ``;
export default CardButtonExtra;
